import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// HOC для защиты маршрутов админ-панели.
// Если пользователь не авторизован — редирект на /login.
// Если авторизован, но не admin — редирект на главную.
const ProtectedAdminRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
